import { KeyValue } from "@/main/models/common";
import { CompanyTypeTypes, CompanyTypeActionTypes } from "./companyTypeTypes";
import { CompanyTypeRequest } from "@/main/models/request/companyTypeRequest";

export function getCompanyType(request: CompanyTypeRequest | null = null): CompanyTypeActionTypes {
	return {
		type: CompanyTypeTypes.GET_COMPANY_TYPE,
		payload: request,
	};
}

export function saveCompanyType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CompanyTypeActionTypes {
	return {
		type: CompanyTypeTypes.SAVE_COMPANY_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function getCompanyTypePublic(): CompanyTypeActionTypes {
	return {
		type: CompanyTypeTypes.GET_COMPANY_TYPE_PUBLIC,
	};
}

export function saveCompanyTypePublic(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CompanyTypeActionTypes {
	return {
		type: CompanyTypeTypes.SAVE_COMPANY_TYPE_PUBLIC,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerCompanyType(): CompanyTypeActionTypes {
	return {
		type: CompanyTypeTypes.RESET_REDUCER_COMPANY_TYPE,
	};
}
